__webpack_require__.p = "https://webcdn.wujieai.com/0.4.0/_next/";